import React, { Component } from 'react';
import '../styles/CardSection.css';

import Zoom from 'react-reveal/Zoom';

import jansen from '../images/labs/janssencilag.png'
import temis from '../images/labs/temis.png';
import msd from '../images/labs/logo-msd.jpg';
import isdin from '../images/labs/isdin.jpg';
import biotoscana from '../images/labs/grupo-biotoscana.png';
import bristol from '../images/labs/bristol-myers.png';
import eczane from '../images/labs/eczane.jpg'
import organon from '../images/labs/organon.png'
import framingham from '../images/labs/framingham.png'
import gsk from '../images/labs/gsk.png';
import aisico from '../images/labs/aisico.png'
import andre from '../images/labs/andre.jpg'
import aspen from '../images/labs/aspen.png'
import biol from '../images/labs/biol.png'
import imvi from '../images/labs/imvi.jpg'
import szama from '../images/labs/szama.png'
import techsphere from '../images/labs/techsphere.svg'
import celnova from '../images/labs/celnova.jpg'
import lundbeck from '../images/labs/lundbeck.png'
import lkm from '../images/labs/lkm.png'
import skintegrity from '../images/labs/skintegrity.png'
import biosintex from '../images/labs/biosintex.png'

import arrowIcon from '../icons/arrow-down.svg';

import * as constUrl from '../config/urlLabs.js';

class CardSection extends Component {
    constructor(props) {
        super(props);
        
        this.toggleCards = this.toggleCards.bind(this);
    }
    openLink(url){
        window.open(url, '_blank');
    }
    toggleCards() {
        let arrow = document.getElementById("arrow")
        if(!arrow.classList.contains("toggle")){
            let cards = Array.prototype.slice.call(document.getElementsByClassName('react-reveal'))
            document.getElementsByClassName(this.props.classContainer)[0].style.height = "2600px"
            cards.forEach(function(element){
                element.style.display = 'block';  
            })
            arrow.style.transform = "rotate(180deg)"
            arrow.classList.add("toggle")
        } else{
            let cards = Array.prototype.slice.call(document.getElementsByClassName('col-mobile')[0].children)
            let cardsToHide = cards.slice(5, cards.length)

            document.getElementsByClassName(this.props.classContainer)[0].style.height = "900px"
            cardsToHide.forEach(function(element){
                element.style.display = 'none';  
            })

            arrow.style.transform = "rotate(0deg)"
            arrow.classList.remove("toggle")
        }
    }
    render(){
        return (
        <div className="Card-Section">
            <div class="lab-card-container">
                <div class="col">
                    <Zoom>
                        <div class="lab-card">
                            <img src={bristol} class="bristol-img" onClick={() => this.openLink(constUrl.BRISTOL)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={aisico} class="aisico-img" onClick={() => this.openLink(constUrl.AISICO)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={organon} class="organon-img" onClick={() => this.openLink(constUrl.ORGANON)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={biosintex} class="biosintex-img" onClick={() => this.openLink(constUrl.BIOSINTEX)}/>
                        </div>
                    </Zoom>
                    
                </div>
                <div class="col">  
                    <Zoom>
                        <div class="lab-card">
                            <img src={gsk} class="glaxo-img" onClick={() => this.openLink(constUrl.GSK)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={andre} class="bristol-img" onClick={() => this.openLink(constUrl.ANDRE)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={eczane} class="eczane-img" onClick={() => this.openLink(constUrl.ECZANE)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={lkm} class="biotoscana-img" onClick={() => this.openLink(constUrl.LKM)}/>
                        </div>
                    </Zoom>
                    
                </div>
                <div class="col">
                    <Zoom>
                        <div class="lab-card">
                            <img src={jansen} class="jansen-img" onClick={() => this.openLink(constUrl.JANSSEN)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={framingham} class="framingham-img" onClick={() => this.openLink(constUrl.FRAMINGHAM)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={biotoscana} class="biotoscana-img" onClick={() => this.openLink(constUrl.GBT)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={lundbeck} class="lundbeck-img" onClick={() => this.openLink(constUrl.LUNDBECK)}/>
                        </div>
                    </Zoom>
                    
                </div>
                <div class="col">
                    <Zoom>
                        <div class="lab-card">
                            <img src={msd} class="msd-img" onClick={() => this.openLink(constUrl.MSD)}/>
                        </div>
                    </Zoom> 
                    <Zoom>
                        <div class="lab-card">
                            <img src={biol} class="biol-img" onClick={() => this.openLink(constUrl.BIOL)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                        <img src={skintegrity} class="skintegrity-img"  onClick={() => this.openLink(constUrl.SKINTEGRITY)}/>
                        </div>
                    </Zoom>    
                    <Zoom>
                        <div class="lab-card">
                        <img src={techsphere} class="techsphere-img" onClick={() => this.openLink(constUrl.TECH)}/>
                        </div>
                    </Zoom> 
                </div>
                <div class="col">
                    <Zoom>
                        <div class="lab-card">
                            <img src={temis} class="temis-img" onClick={() => this.openLink(constUrl.TEMIS)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={celnova} class="celnova-img" onClick={() => this.openLink(constUrl.CELNOVA)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={isdin} class="isdin-img" onClick={() => this.openLink(constUrl.ISDIN)}/>
                        </div>
                    </Zoom>
                 
                </div>

                <div class="col-mobile">
                    <Zoom>
                        <div class="lab-card">
                            <img src={bristol} class="bristol-img" onClick={() => this.openLink(constUrl.BRISTOL)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={gsk} class="glaxo-img" onClick={() => this.openLink(constUrl.GSK)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={jansen} class="jansen-img" onClick={() => this.openLink(constUrl.JANSSEN)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={msd} class="msd-img" onClick={() => this.openLink(constUrl.MSD)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                        <img src={temis} class="temis-img" onClick={() => this.openLink(constUrl.TEMIS)}/>
                        </div>
                    </Zoom>

                    <Zoom>
                        <div class="lab-card">
                        <img src={aisico} class="aisico-img" onClick={() => this.openLink(constUrl.AISICO)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                        <img src={andre} class="bristol-img" onClick={() => this.openLink(constUrl.ANDRE)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                        <img src={aspen} class="aspen-img" onClick={() => this.openLink(constUrl.ASPEN)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                        <img src={biol} class="biol-img" onClick={() => this.openLink(constUrl.BIOL)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={celnova} class="celnova-img" onClick={() => this.openLink(constUrl.CELNOVA)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={eczane} class="eczane-img" onClick={() => this.openLink(constUrl.ECZANE)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={biotoscana} class="biotoscana-img" onClick={() => this.openLink(constUrl.GBT)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={imvi} class="imvi-img" onClick={() => this.openLink(constUrl.IMVI)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={isdin} class="isdin-img" onClick={() => this.openLink(constUrl.ISDIN)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={lkm} class="biotoscana-img" onClick={() => this.openLink(constUrl.LKM)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={lundbeck} class="lundbeck-img" onClick={() => this.openLink(constUrl.LUNDBECK)}/>
                        </div>
                    </Zoom>

                    <Zoom>
                        <div class="lab-card">
                            <img src={skintegrity} class="skintegrity-img" />
                        </div>
                    </Zoom>                   
                    <Zoom>
                        <div class="lab-card">
                            <img src={techsphere} class="techsphere-img" onClick={() => this.openLink(constUrl.TECH)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={organon} class="organon-img" onClick={() => this.openLink(constUrl.ORGANON)}/>
                        </div>
                    </Zoom>
                    <Zoom>
                        <div class="lab-card">
                            <img src={framingham} class="framingham-img" onClick={() => this.openLink(constUrl.FRAMINGHAM)}/>
                        </div>
                    </Zoom>
                </div>
            </div>
            <div>
                <img src={arrowIcon} id="arrow" class="icon-arrow" onClick={this.toggleCards}/>
            </div>
        </div>
        )
    }
}

export default CardSection


// WEBPACK FOOTER //
// ./src/components/CardSection.js